var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.678,
    height: 78.738,
    viewBox: "0 0 70.678 78.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1629",
    "data-name": "Group 1629",
    transform: "translate(-371.801 -548.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "conversation",
    transform: "translate(372.001 557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6823",
    "data-name": "Path 6823",
    d: "M313.948,0H293.254a5,5,0,0,0-5,5V21.24a5,5,0,0,0,5,5h2.382v2.641a1.035,1.035,0,0,0,1.709.771l3.868-3.413h12.736a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Zm2.939,21.24a2.943,2.943,0,0,1-2.939,2.939H300.824a1.029,1.029,0,0,0-.681.257l-2.45,2.162V25.208a1.029,1.029,0,0,0-1.029-1.029h-3.41a2.943,2.943,0,0,1-2.939-2.939V5a2.943,2.943,0,0,1,2.939-2.939h20.694A2.943,2.943,0,0,1,316.888,5Z",
    transform: "translate(-248.72 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6824",
    "data-name": "Path 6824",
    d: "M201.257,37.5a1.026,1.026,0,0,0,.726-.3l2.934-2.925a1.029,1.029,0,0,0-1.453-1.457l-2.934,2.925A1.054,1.054,0,0,0,201.257,37.5Z",
    transform: "translate(-172.788 -28.058)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6825",
    "data-name": "Path 6825",
    d: "M177.059,19.854a1.107,1.107,0,0,0,1.116-.933l.367-4.127a1.029,1.029,0,0,0-2.049-.182l-.367,4.127A1.029,1.029,0,0,0,177.059,19.854Z",
    transform: "translate(-151.965 -11.824)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6826",
    "data-name": "Path 6826",
    d: "M211.8,76.027a1.107,1.107,0,0,0,1.113.937l4.128-.355a1.029,1.029,0,0,0-.176-2.05l-4.128.355A1.029,1.029,0,0,0,211.8,76.027Z",
    transform: "translate(-182.745 -64.329)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6827",
    "data-name": "Path 6827",
    d: "M440.878,276.276l2.934-2.925a1.029,1.029,0,0,0-1.452-1.457l-2.934,2.925A1.029,1.029,0,0,0,440.878,276.276Z",
    transform: "translate(-378.891 -234.34)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6828",
    "data-name": "Path 6828",
    d: "M416.23,258.931a1.029,1.029,0,0,0,1.023-.937l.368-4.127a1.029,1.029,0,0,0-2.049-.182l-.368,4.127A1.105,1.105,0,0,0,416.23,258.931Z",
    transform: "translate(-358.253 -218.107)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6829",
    "data-name": "Path 6829",
    d: "M456.322,313.631l-4.128.355a1.031,1.031,0,0,0,.176,2.05l4.128-.355A1.029,1.029,0,0,0,456.322,313.631Z",
    transform: "translate(-389.413 -270.61)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6830",
    "data-name": "Path 6830",
    d: "M53.969,75.692a5.776,5.776,0,0,0-8.138,0l-4.088,4.073a4.488,4.488,0,0,1-6.323,0L25.82,70.2a4.477,4.477,0,0,1,0-6.289L29.9,59.842a5.8,5.8,0,0,0,0-8.13L20.86,42.7a5.776,5.776,0,0,0-8.138,0l-2,1.989a17.654,17.654,0,0,0,0,25.029l8.436,8.406-1.428,1.26H5a5,5,0,0,0-5,5v16.243a5,5,0,0,0,5,5H25.691a5,5,0,0,0,5-5V89.611c4.689,4.562,8,9.138,14.97,10.166a1.03,1.03,0,0,0,.323-2.032,15.6,15.6,0,0,1-8.615-4.386l-6.677-6.653V84.383a5,5,0,0,0-5-5H23.31V76.745a1.037,1.037,0,0,0-1.709-.771l-.893.788-8.53-8.5a15.67,15.67,0,0,1-.7-21.367l2.561,2.552a1.029,1.029,0,0,0,1.452-1.457l-2.579-2.57,1.265-1.261a3.715,3.715,0,0,1,5.234,0l9.043,9.011a3.733,3.733,0,0,1,0,5.215l-1.265,1.261-7.5-7.478a1.029,1.029,0,0,0-1.452,1.457l7.5,7.473-1.36,1.355a6.569,6.569,0,0,0,0,9.2l9.6,9.566a6.549,6.549,0,0,0,9.227,0l1.365-1.36,14.254,14.2a15.652,15.652,0,0,1-6.9,3.5,1.031,1.031,0,0,0,.448,2.008,17.719,17.719,0,0,0,8.66-4.753l1.992-1.984a5.8,5.8,0,0,0,0-8.13ZM22.281,81.443h3.41a2.943,2.943,0,0,1,2.939,2.939v16.243a2.943,2.943,0,0,1-2.939,2.939H5a2.943,2.943,0,0,1-2.939-2.94V84.383A2.943,2.943,0,0,1,5,81.443H18.122a1.029,1.029,0,0,0,.681-.257l2.45-2.162v1.391A1.029,1.029,0,0,0,22.281,81.443Zm39.28,9.932L60.3,92.636,46.018,78.41l1.265-1.261a3.715,3.715,0,0,1,5.234,0l9.043,9.011A3.733,3.733,0,0,1,61.561,91.376Z",
    transform: "translate(0 -35.398)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6831",
    "data-name": "Path 6831",
    d: "M353.535,65.21H338.295a1.029,1.029,0,0,0,0,2.057h15.241A1.029,1.029,0,0,0,353.535,65.21Z",
    transform: "translate(-291.034 -56.266)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6832",
    "data-name": "Path 6832",
    d: "M348.049,111.229h-9.754a1.029,1.029,0,0,0,0,2.057h9.754A1.029,1.029,0,0,0,348.049,111.229Z",
    transform: "translate(-291.034 -95.973)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6833",
    "data-name": "Path 6833",
    d: "M48.812,388.9a1.029,1.029,0,0,0,1.029,1.029H65.081a1.029,1.029,0,0,0,0-2.057H49.841A1.029,1.029,0,0,0,48.812,388.9Z",
    transform: "translate(-42.117 -334.67)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6834",
    "data-name": "Path 6834",
    d: "M59.791,433.888H50.037a1.029,1.029,0,0,0,0,2.057h9.754A1.029,1.029,0,0,0,59.791,433.888Z",
    transform: "translate(-42.313 -374.377)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6842",
    "data-name": "Path 6842",
    d: "M3.65,123.689H1.964v1.964H0v1.686H1.964V129.3H3.65v-1.964H5.614v-1.686H3.65Z",
    transform: "translate(371.898 468.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6841",
    "data-name": "Path 6841",
    d: "M3.65,123.689H1.964v1.964H0v1.686H1.964V129.3H3.65v-1.964H5.614v-1.686H3.65Z",
    transform: "translate(376.898 425.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6843",
    "data-name": "Path 6843",
    d: "M32.166,53.325h2.8v2.8h-2.8Z",
    transform: "translate(398.512 495.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6845",
    "data-name": "Path 6845",
    d: "M32.166,53.325h2.8v2.8h-2.8Z",
    transform: "translate(380.512 536.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6844",
    "data-name": "Path 6844",
    d: "M160.169,173.9v2.8h-2.8v-2.8Zm0,5.6v2.8h-2.8v-2.8Z",
    transform: "translate(282.309 444.954)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.f1be4e2610d888abd63392f2fdf23bf1.svg";
export { ForwardRef as ReactComponent };